import { render, staticRenderFns } from "./validationErrorDialog.vue?vue&type=template&id=77a2a56d&scoped=true&"
import script from "./validationErrorDialog.vue?vue&type=script&lang=js&"
export * from "./validationErrorDialog.vue?vue&type=script&lang=js&"
import style0 from "./validationErrorDialog.vue?vue&type=style&index=0&id=77a2a56d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a2a56d",
  null
  
)

export default component.exports